module.exports = __webpack_public_path__ + "img/xj2.84a747f8.png";